import authRequest from 'utils/authRequest'
import studentRequest from 'utils/studentRequest'
import instituteRequest from 'utils/instituteRequest'
import corporateRequestfrom from 'utils/corporateRequest'
import adminRequest from 'utils/adminRequest'
import localRequest from './localRequest'
import authRequested from './authRequested'


const initializeApp = token => {
  authRequest.defaults.headers.common['Authorization'] = token
  studentRequest.defaults.headers.common['Authorization'] = token
  instituteRequest.defaults.headers.common['Authorization'] = token
  corporateRequestfrom.defaults.headers.common['Authorization'] = token
  localRequest.defaults.headers.common['Authorization'] = token
  adminRequest.defaults.headers.common['Authorization'] = token
  authRequested.defaults.headers.common['Authorization'] = token
}

export default initializeApp
